import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Dialog from "../../../components/Dialog";
import ModalCallback from "../../../model/ModalCallback";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import { StyledDefaultButtonLink } from "../../../styles/pages/AcademicActivityPlanStyles";
import { StyledActionContainer } from "../../../styles/pages/Workflows/InformationTach";
import HeaderTachModal from "./components/HeaderTachModal";
import DialogMessage from "../../../components/DialogMessage";
import DialogMessageProps from "../../../model/DialogMessageProps";
import { TypeDialogMessageEnum } from "../../../model/Enums/TypeDialogMessageEnum";
import { useTachDocWorkflow } from "../../../context/TachDocumentContext";
import GenericUtils from "../../../utils/GenericUtils";
import WorkflowService from "../../../service/Docente/WorkflowService";
import { useWorkflow } from "../../../context/WorkflowContext";

const { BtnPrimary } = ButtonStyles;

type Modal = {
    open: boolean;
    onClose: (callback?: ModalCallback) => void;
    status: boolean;
    endProcess: () => void;
    processId: string;
    visibility?: boolean;
};

const ModalConfirmAction = ({
    open,
    onClose,
    status,
    endProcess,
    processId,
    visibility,
}: Modal) => {
    const { instance } = useMsal();
    const { workflowFilter, filterWorkflows } = useWorkflow();
    const [success, setSuccess] = useState(false);
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const { justification } = useTachDocWorkflow();
    const [showDialog, setShowDialog] = useState(visibility ?? true);

    const handleCloseDialogMessage = () => {
        setDialogMessageProps({} as DialogMessageProps);
    };

    const handleSubmit = async () => {
        const dataPost = {
            justificativa: justification,
            action: status ? "CANCEL" : "APPROVE",
        };

        const response = await WorkflowService.patchProcessTach(
            instance,
            processId,
            dataPost
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setSuccess(true);
        }

        const dialog = {
            ...GenericUtils.getPropsDialogError(response),
            onClose: handleCloseDialogMessage,
        };
        setShowDialog(false);
        setDialogMessageProps(dialog);
    };

    const typeDialogMessage = (typeIcon: any) => {
        return success ? TypeDialogMessageEnum.Success : typeIcon;
    };

    const textMessage = (message: any) => {
        if (success) {
            return status ? "TACH Cancelado" : "TACH aprovado com sucesso!";
        }

        return message && message.length
            ? message
            : "Ocorreu um erro ao processar sua solicitação.";
    };

    const finishProcess = () => {
        onClose();
        endProcess();
        filterWorkflows(workflowFilter);
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={typeDialogMessage(dialogMessageProps.type)}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={textMessage(dialogMessageProps.text)}
            onClose={finishProcess}
        />
    );

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <Dialog openModal={open} onHide={onClose} className={dialogClass}>
            <HeaderTachModal
                title={status ? "Cancelar TACH" : "Aprovar TACH?"}
            />
            <StyledActionContainer>
                <BtnPrimary onClick={() => handleSubmit()}>Sim</BtnPrimary>
                <StyledDefaultButtonLink variant="link" onClick={onClose}>
                    {status ? "Não" : "Voltar"}
                </StyledDefaultButtonLink>
            </StyledActionContainer>
            {dialogMessage}
        </Dialog>
    );
};

export default ModalConfirmAction;
